import { render } from "./pendingDownloads.vue?vue&type=template&id=2442375a&scoped=true"
import script from "./pendingDownloads.vue?vue&type=script&lang=js"
export * from "./pendingDownloads.vue?vue&type=script&lang=js"

import "./pendingDownloads.vue?vue&type=style&index=0&id=2442375a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2442375a"]])

export default __exports__